export default {
  apiBaseUrl: 'https://ireland-stage-account-api.august.com',
  showVersions: true,
  enableTranslations: false,
  signInWithApple: {
    redirectURI: 'https://account-stage-aws.august.com/auth/apple/callback',
  },
};
